export var stepsSizes=["m","s","l"];export var stepsDefaultSize=stepsSizes[0];
//# sourceMappingURL=types.js.map